// core/domain/repositories/lead/lead.repository.ts

import { Observable } from 'rxjs';
import { CreateLeadRequest, CreateLeadResponse } from '../../interfaces/lead/lead.interface';

export abstract class LeadRepository {
  abstract createLead(request: CreateLeadRequest): Observable<CreateLeadResponse>;
  // ✅ Actualizar lead existente
  abstract updateLead(leadId: string, request: CreateLeadRequest): Observable<CreateLeadResponse>;
}